export const getTotalAccH = (showChild) => {
  return [{
          label: '科目编码',
          value: 'code',
          show: 'normal',
        },{
          label: '名称',
          value: 'name',
          show: 'template'
        },{
          label: '期间',
          value: 'yearPeriods',
          show: 'normal',
        },{
          label: '摘要',
          value: 'summary',
          show: 'normal'
        },{
          label: '借方',
          value: 'debitMoney',
          show: 'template',
          showChild : showChild || false,
          children:[
            {
              label: '原币',
              value: 'debitCoin',
              show: 'template',
            },{
              label: '本位币',
              value: 'debitMoney',
              show: 'template',
            }
          ]
        },{
          label: '贷方',
          value: 'creditorMoney',
          show: 'template',
          showChild : showChild || false,
          children:[
            {
              label: '原币',
              value: 'creditorCoin',
              show: 'template'
            },{
              label: '本位币',
              value: 'creditorMoney',
              show: 'template'
            }
          ]
        },{
          label: '方向',
          value: 'creditDirection',
          show: 'normal',
          width: 50,
        },{
          label: '余额',
          value: 'remainingSum',
          show: 'template',
          showChild : showChild || false,
          children:[
            {
              label: '原币',
              value: 'remainingCoin',
              show: 'template'
            },{
              label: '本位币',
              value: 'remainingSum',
              show: 'template'
            }
          ]
      }]
}


// WEBPACK FOOTER //
// ./src/pages/accountBook/config/tableHead.js